/**
 * header-mega-menu-custom.js
 * Hover on desktop (>=990px), click on mobile (<990px)
 * Works with Dawn's native details/summary + header-menu web component
 */

(function () {
  'use strict';

  const BREAKPOINT  = 990;
  const OPEN_DELAY  = 50;
  const CLOSE_DELAY = 120;

  class MegaMenuHover {
    constructor(nav) {
      this.nav     = nav;
      this.details = Array.from(nav.querySelectorAll('details.mega-menu--custom'));
      if (!this.details.length) return;

      this._openTimer  = null;
      this._closeTimer = null;

      this._bind();
    }

    _bind() {
      this.details.forEach(detail => {
        const summary  = detail.querySelector('summary');
        const dropdown = detail.querySelector('.mega-menu__content--custom');

        /* ---- Desktop: intercept click on summary, use hover instead ---- */
        summary.addEventListener('click', (e) => {
          if (this._isDesktop()) {
            e.preventDefault();
            e.stopPropagation();
            /* Navigate to the link URL on desktop click */
            const link = summary.closest('a') || summary.querySelector('a');
            if (!link) {
              /* summary itself is the trigger — navigate to href if any */
              const href = summary.getAttribute('data-href');
              if (href) window.location.href = href;
            }
          }
        });

        /* ---- Desktop: hover open/close ---- */
        detail.addEventListener('mouseenter', () => {
          if (!this._isDesktop()) return;
          clearTimeout(this._closeTimer);
          this._openTimer = setTimeout(() => {
            this._closeAll(detail);
            this._open(detail);
          }, OPEN_DELAY);
        });

        detail.addEventListener('mouseleave', () => {
          if (!this._isDesktop()) return;
          clearTimeout(this._openTimer);
          this._closeTimer = setTimeout(() => {
            this._close(detail);
          }, CLOSE_DELAY);
        });

        /* ---- Keyboard: Escape closes ---- */
        detail.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') {
            this._close(detail);
            summary.focus();
          }
        });
      });

      /* Close all on outside click */
      document.addEventListener('click', (e) => {
        if (!this.nav.contains(e.target)) this._closeAll();
      });

      /* Close all when user scrolls on desktop */
      window.addEventListener('wheel', () => {
        if (!this._isDesktop()) return;
        clearTimeout(this._openTimer);
        clearTimeout(this._closeTimer);
        this._closeAll();
      }, { passive: true });

      /* Reset on breakpoint cross */
      let lastW = window.innerWidth;
      window.addEventListener('resize', () => {
        const w = window.innerWidth;
        if ((lastW < BREAKPOINT) !== (w < BREAKPOINT)) this._closeAll();
        lastW = w;
      });
    }

    _open(detail) {
      detail.setAttribute('open', '');
      detail.querySelector('summary')?.setAttribute('aria-expanded', 'true');
    }

    _close(detail) {
      detail.removeAttribute('open');
      detail.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    }

    _closeAll(except = null) {
      this.details.forEach(d => { if (d !== except) this._close(d); });
    }

    _isDesktop() {
      return window.innerWidth >= BREAKPOINT;
    }
  }

  function init() {
    document.querySelectorAll('.header__inline-menu').forEach(nav => {
      if (!nav._megaHoverInit) {
        nav._megaHoverInit = true;
        new MegaMenuHover(nav);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('.header__inline-menu').forEach(nav => {
      nav._megaHoverInit = false;
    });
    init();
  });

})();